import { render, staticRenderFns } from "./current-position.vue?vue&type=template&id=72cae150&"
import script from "./current-position.vue?vue&type=script&lang=js&"
export * from "./current-position.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports